<cam-button type="secondary" [size]="this.size()" icon="eye" (action)="this.open()">
  @if (this.label(); as label) {
    {{ label }}
  }
</cam-button>

<cam-layout-full-panel
  [toggleState]="!!this.isOpen"
  (closeEvent)="this.close()"
  [title]="'core.views-selection.title' | translate"
>
  <ng-template [ngTemplateOutlet]="template"></ng-template>
</cam-layout-full-panel>

<ng-template #template>
  <cam-views-selection
    class="d-flex full-width"
    [gridId]="this.gridId()"
    (OSselected)="this.close()"
  ></cam-views-selection>
</ng-template>
